// extracted by mini-css-extract-plugin
export default {"division1":"PartnerContent2_division1__tglaU","division1Text":"PartnerContent2_division1Text__Gpgff","division1Title":"PartnerContent2_division1Title__ZlRzI"};